import { useEffect, useRef, useState } from 'react';
import { makeStyles, Paper, Portal } from '@material-ui/core';
import { useShadowRootElements } from '@backstage/plugin-techdocs-react';
import { CodeSnippet } from './CodeSnippet';

const useStyles = makeStyles({
  container: {
    position: 'relative',
  },
});

const EmbeddedCodeSnippet = (props: { element: HTMLPreElement }) => {
  const { element } = props;
  const containerRef = useRef<HTMLElement | undefined>(undefined);
  const [success, setSuccessState] = useState<boolean>(false);
  const classes = useStyles();
  useEffect(() => {
    if (!containerRef.current) {
      const container = document.createElement('div');
      element.parentNode?.insertBefore(container, element.nextSibling);
      containerRef.current = container;
    }
  }, [containerRef, element]);
  useEffect(() => {
    if (success) {
      element.style.display = 'none';
    }
  }, [success, element]);
  const code = element.querySelector('code');
  if (containerRef.current && code) {
    const language =
      [...code.classList]
        .find(cls => cls.startsWith('language-'))
        ?.substring(9) ?? 'text';
    const text = code?.textContent ?? '';
    return (
      <Portal container={containerRef.current}>
        <Paper className={classes.container}>
          <CodeSnippet
            language={language}
            code={text}
            onSuccess={() => {
              // NOTE (andy.vaughn, 20250324) hacky microtask, outside of the render stage
              // will look into a cleaner way to handle this
              Promise.resolve().then(() => setSuccessState(true));
            }}
          />
        </Paper>
      </Portal>
    );
  }
  return null;
};

export const TechDocsCodeSnippetsAddon = () => {
  const elements = useShadowRootElements<HTMLPreElement>([
    'pre.highlight',
  ]).filter(pre => pre.querySelector('code'));
  return (
    <>
      {elements.map((e, index) => (
        <EmbeddedCodeSnippet key={index} element={e} />
      ))}
    </>
  );
};
